import LoginLink from "~/components/molecules/LoginLink";
import imgaLogo from "~/assets/imga-plus-text-white.png";
import ascenderLogo from "~/assets/ascender-logo-white.svg";
import Image from "~/components/atoms/Image";

export default function ProductBanner({ loginReturnTo }: { loginReturnTo: string }) {
    return (
        <div className="flex h-20 w-full items-center justify-center bg-blue-80">
            <div className="flex w-full max-w-[1290px]">
                <Image
                    src={imgaLogo}
                    alt="IMGA Premier Logo"
                    className="mb-3 hidden h-8 pl-7 sm:flex"
                />
                <Image
                    src={ascenderLogo}
                    alt="IMGA Premier Logo"
                    className="mb-3 mr-4 flex pl-7 sm:hidden"
                />
                <div className="mt-3 font-bold text-white"> beta</div>
                <LoginLink returnTo={loginReturnTo} />
            </div>
        </div>
    );
}
